var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSchedule = function SvgSchedule(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#105880",
    d: "M12.07 4.56h-1.03V3h-1.3v3.89h1.3V5.85h1.03v-1.3Zm-3.37 0H7.67V3h-1.3v3.89h1.3V5.85H8.7v-1.3Zm-5.7 0V17h13.74V4.56h-2.33V3h-1.3v3.89h1.3V5.85h1.03v9.85H4.3V5.85h1.03v-1.3H3Z"
  })));
};
export default SvgSchedule;